import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  // Avatar,
  Divider,
  Grid,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { Helmet } from "react-helmet";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BlockIcon from "@mui/icons-material/Block";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";

// import  logo from "../images/Flavrapogi-Logo.png"; 

const ShippingDeliveryPolicy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Helmet>
        <title>Shipping & Delivery Policy | Flavrapogi</title>

        <meta
          name="description"
          content="Read the Shipping and Delivery Policy of Flavrapogi."
        />
      </Helmet>

      <Container
        maxWidth="100vw"
        sx={{
          minHeight: "100vh",
          py: 6,
          background: `
            linear-gradient(
              135deg,
              #1e293b 0%,
              #0f172a 20%,
              #312e81 50%,
              #4338ca 75%,
              #818cf8 100%
            )
          `,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            textAlign: "center",
            color: "white",
            mb: 6,
            mt: 3,
          }}
        >
          {/* <Avatar
            src={logo}
            sx={{
              width: isMobile ? 85 : 110,
              height: isMobile ? 85 : 110,
              mx: "auto",
              mb: 2,
              boxShadow: "0 14px 35px rgba(0,0,0,0.35)",
            }}
          /> */}

          <Chip
            label="Policy Information"
            sx={{
              mb: 2,
              background: "rgba(255,255,255,0.15)",
              color: "white",
              fontWeight: 600,
              backdropFilter: "blur(10px)",
            }}
          />

          <Typography
            variant={isMobile ? "h4" : "h3"}
            sx={{
              fontWeight: 800,
              mb: 1,
              letterSpacing: 1,
            }}
          >
            Shipping & Delivery Policy
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "rgba(255,255,255,0.85)",
            }}
          >
            Last updated on April 1, 2025
          </Typography>
        </Box>

        {/* Main Wrapper */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1350px",
            }}
          >
            {/* Hero Section */}
            <Paper
              elevation={0}
              sx={{
                p: { xs: 4, md: 7 },
                borderRadius: 6,
                mb: 5,
                textAlign: "center",
                background: "rgba(255,255,255,0.12)",
                backdropFilter: "blur(14px)",
                border: "1px solid rgba(255,255,255,0.18)",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/* Background Glow */}
              <Box
                sx={{
                  position: "absolute",
                  width: 300,
                  height: 300,
                  borderRadius: "50%",
                  background: "rgba(129,140,248,0.18)",
                  top: -100,
                  right: -80,
                  filter: "blur(40px)",
                }}
              />

              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                }}
              >
                {/* Icons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                    mb: 4,
                    flexWrap: "wrap",
                  }}
                >
                  <Box
                    sx={{
                      width: 90,
                      height: 90,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #4f46e5, #818cf8)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 12px 30px rgba(79,70,229,0.35)",
                    }}
                  >
                    <LocalShippingIcon
                      sx={{
                        fontSize: 42,
                        color: "white",
                      }}
                    />
                  </Box>

                  <BlockIcon
                    sx={{
                      fontSize: 55,
                      color: "#f87171",
                    }}
                  />
                </Box>

                <Typography
                  variant={isMobile ? "h4" : "h3"}
                  sx={{
                    fontWeight: 700,
                    color: "white",
                    mb: 3,
                  }}
                >
                  Shipping is Not Applicable
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    lineHeight: 1.9,
                    maxWidth: "950px",
                    mx: "auto",
                    fontWeight: 400,
                  }}
                >
                  FLAVR APOGI HEALTHCARE AND INDUSTRIAL CATERING SERVICES
                  PRIVATE LIMITED does not provide shipping services as our
                  business model does not require physical delivery of products.
                </Typography>
              </Box>
            </Paper>

            {/* Information Cards */}
            <Grid container spacing={4}>
              {/* Why No Shipping */}
              <Grid item xs={12} md={6}>
                <Paper
                  sx={{
                    p: { xs: 3, md: 4 },
                    borderRadius: 5,
                    height: "100%",
                    background:
                      "linear-gradient(145deg, rgba(255,255,255,0.96), rgba(238,242,255,0.92))",
                    backdropFilter: "blur(12px)",
                    border: "1px solid rgba(255,255,255,0.4)",
                    transition: "0.3s ease",
                    boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
                    "&:hover": {
                      transform: "translateY(-5px)",
                    },
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "#4338ca",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Policy Overview
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 2,
                      color: "#334155",
                    }}
                  >
                    Our services are designed in a way that does not require
                    physical shipping or courier delivery. Therefore, no
                    shipping timelines, tracking, or delivery charges are
                    applicable to our business operations.
                  </Typography>
                </Paper>
              </Grid>

              {/* Contact */}
              <Grid item xs={12} md={6}>
                <Paper
                  sx={{
                    p: { xs: 3, md: 4 },
                    borderRadius: 5,
                    height: "100%",
                    background:
                      "linear-gradient(135deg, #4338ca, #6366f1, #818cf8)",
                    color: "white",
                    boxShadow: "0 14px 35px rgba(67,56,202,0.3)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      width: 180,
                      height: 180,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.1)",
                      top: -60,
                      right: -40,
                    }}
                  />

                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={2}
                      mb={3}
                    >
                      <ContactSupportIcon
                        sx={{
                          fontSize: 36,
                        }}
                      />

                      <Typography variant="h5" fontWeight={700}>
                        Need Help?
                      </Typography>
                    </Box>

                    <Divider
                      sx={{
                        mb: 3,
                        borderColor: "rgba(255,255,255,0.2)",
                      }}
                    />

                    <Typography
                      variant="body1"
                      sx={{
                        lineHeight: 2,
                        color: "rgba(255,255,255,0.92)",
                      }}
                    >
                      For any questions regarding our services, please contact
                      us:
                    </Typography>

                    <Box mt={3}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                        }}
                      >
                        📧 flavrapogi@gmail.com
                      </Typography>

                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                        }}
                      >
                        📞 9840110545
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ShippingDeliveryPolicy;